import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { DataProvider } from './DataContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Account from './pages/Account';
import Campaigns from './pages/Campaigns';
import Calls from './pages/Calls';
import Config from './pages/Config';
import Activity from './pages/Activity';
import Billing from './pages/Billing';
import Usuarios from './pages/Usuarios';
import FlujosVoz from './pages/FlujosVoz';
import Layout from './components/Layout';
import Aurora from './components/Aurora';
import Verificar from './pages/Verificar';
import OnboardingTour from './components/OnboardingTour';
import AdminDashboard from './pages/AdminDashboard';
import AdminLive from './pages/AdminLive';
import AdminClientes from './pages/AdminClientes';
import AdminClienteDetalle from './pages/AdminClienteDetalle';
import AdminEventos from './pages/AdminEventos';

const Private = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function AppWithTour() {
  const navigate = useNavigate();
  return (
    <>
      <OnboardingTour navigate={navigate} />
      <Layout />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Aurora />
      <Routes>
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verificar" element={<Verificar />} />
        <Route path="/" element={
          <Private>
            <DataProvider>
              <AppWithTour />
            </DataProvider>
          </Private>
        }>
          <Route index          element={<Dashboard />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="calls"     element={<Calls />} />
          <Route path="flujos-voz" element={<FlujosVoz />} />
          <Route path="config"    element={<Config />} />
          <Route path="activity"       element={<Activity />} />
          <Route path="account"        element={<Account />} />
          <Route path="usuarios"       element={<Usuarios />} />
          <Route path="billing"         element={<Billing />} />
          <Route path="admin"           element={<AdminDashboard />} />
          <Route path="admin/live"      element={<AdminLive />} />
          <Route path="admin/clientes"  element={<AdminClientes />} />
          <Route path="admin/clientes/:id" element={<AdminClienteDetalle />} />
          <Route path="admin/eventos" element={<AdminEventos />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
